import { createAsyncThunk } from '@reduxjs/toolkit';
import { IGetAdminAwards } from 'entities/competitions-b2b/types';
import { AxiosError, AxiosResponse } from 'axios';
import { mainServiceWithCredentials } from 'shared/services/http';
import { store } from 'app/store';
import { toast } from 'react-toastify';
import { competitionsB2BApi } from 'entities/competitions-b2b/api';
import { setDrawerOpen } from '../../ui/model/uiSlice';
import { IRequestData } from './types';

const updateAwardsThunk = createAsyncThunk(
  'competitionsApi/updateAwardsThunk',
  async (requestData: IRequestData, thunkAPI) => {
    try {
      const data: AxiosResponse<IGetAdminAwards.Response> = await mainServiceWithCredentials.post(
        `competitions/admin/competition/${requestData.competition_id}/award`,
        requestData.body,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${store.getState().auth.token}`,
          },
        },
      );

      toast.success('Призовые места сохранены');

      thunkAPI.dispatch(setDrawerOpen(false));
      thunkAPI.dispatch(competitionsB2BApi.util.invalidateTags(['competitionAwardPlaces']));

      return data.data;
    } catch (e) {
      const { detail } = ((e as AxiosError).response as any).data;

      toast.error(detail, {
        position: toast.POSITION.TOP_RIGHT,
      });
      thunkAPI.dispatch(setDrawerOpen(false));
    }
  },
);

const getAwardsThunk = createAsyncThunk('competitionsApi/getAwardsThunk', async (competition_id: number, thunkAPI) => {
  try {
    const data: AxiosResponse<IGetAdminAwards.Response> = await mainServiceWithCredentials.get(
      `competitions/admin/competition/${competition_id}/award`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${store.getState().auth.token}`,
        },
      },
    );
    return data.data;
  } catch (e) {
    toast.error('Произошла ошибка при получении наград');
    thunkAPI.dispatch(setDrawerOpen(false));
  }
});

export { updateAwardsThunk, getAwardsThunk };
